import axios from "axios";
import * as types from '@/store/types';
import get from 'lodash/get';

export default {
  async setLocale({ commit, rootState }, locale) {
    commit(types.SET_LOCALE, locale);
    if (get(rootState, 'auth.user.id', false)) {
      await axios.put(`/api/web/user/${rootState.auth.user.id}`, {
        language_id: locale === 'en' ? '1' : '2',
      });
    }
  }
};
